import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;

  margin: 0 auto;
  padding: ${themeGet('spacing.xl')};
  height: ${pxToRem(250)};

  box-sizing: border-box;

  border-radius: ${themeGet('borderRadius.md')};
  border: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
  box-shadow: ${themeGet('dropShadow.100')};
`;
export const PreviewOverlay = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  pointer-events: none;

  background: linear-gradient(to bottom, transparent 0%, ${themeGet('colors.background.50')} 100%);
`;
export const PreviewContent = styled.div `
  transition: opacity 0.2s ease-in-out;
  opacity: 1;
`;
export const CardBody = styled.button `
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: left;
  overflow: hidden;
  height: 100%;
  margin: 0;
  padding: 0;
  border: none;

  word-wrap: break-word;
  text-align: left;

  cursor: pointer;

  &:hover {
    ${PreviewOverlay} {
      opacity: 1;
    }

    ${PreviewContent} {
      opacity: 0.5;
    }
  }
`;
